import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import { currentDateSingle, textDateFormatter } from "../../utils/utils";
import { Link, useLocation, useParams } from "react-router-dom";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import Loader from "../../CustomComponents/Loader/Loader";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";

const Rates = () => {
  const [loader, setLoader] = useState(false);
  const [ratesData, setRatesData] = useState([]);
  const location = useLocation();
  const [updatePopup, setUpdatePopup] = useState(false);
  const [startDate, setStartDate] = useState(currentDateSingle);

  const { id: propertyId } = useParams();

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const vendorToken = localStorage.getItem("token");

  useEffect(() => {
    if (propertyId) {
      ratesDetails(propertyId);
    }
  }, [propertyId, location, startDate]);

  const ratesDetails2 = (id) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-rates/${id}/list?filterDate=${startDate}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setRatesData(result?.rates);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => setLoader(false));
  };

  const ratesDetails = async (id) => {
    setLoader(true);
    try {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${vendorToken}`);
      headers.append("Cookie", process.env.REACT_APP_COOKIE);

      const formData = new FormData();
      formData.append("filterDate", startDate);

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: formData,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/room-rates/fetch/${id}`,
        requestOptions
      );

      const result = await response.json();
      if (result.success) {
        setRatesData(result?.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching room rates:", error);
    }
  };

  const handleOnUpdate = () => {
    setUpdatePopup(true);
  };

  const getMonthText = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return monthNames[new Date(date).getMonth()];
  };
  const [activeIndex, setActiveIndex] = useState([0]);

  const handleToggle = (index) => {
    setActiveIndex((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const [isExpanded, setIsExpanded] = useState({});

  const toggleAccordion = (index, planType) => {
    const key = `${index}-${planType}`;
    setIsExpanded((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <>
      <div className="">
        {/* <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}
        <section className="mt-20 bg-white-div p_0 mt-10">
          <div className="flex justify_content_between align_items_center p_10">
            <h4>Rates</h4>
            <div className="flex flex_gap_10">
              {/* <button className="secondary_btn fit-width">
                {textDateFormatter(currentDateSingle)}
              </button> */}
              <div className="">
                <input
                  type="date"
                  className="dateBtn_inventory m_0 fit-width"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  // ref={dateInputRef}
                />
              </div>
              <Link
                className="vendor_common_property"
                to={`/vendor/property/rate/bulk-update/${propertyId}`}
              >
                Bulk Update
              </Link>
            </div>
          </div>

          {loader ? (
            <Loader size="4em" color="#009A50" />
          ) : (
            <div className="overflow_x_scroll_y_hidden">
              {ratesData?.length > 0 ? (
                <>
                  <table className="rates_table m_0">
                    <tr>
                      <th style={{ borderTop: "0.5px solid #cccccc96" }}>
                        Room Category
                      </th>
                      <th style={{ borderTop: "0.5px solid #cccccc96" }}></th>
                      {Object.keys(ratesData[0]?.rate)
                        .slice(0, 1)
                        .map((planType, index) => (
                          <React.Fragment key={index}>
                            {ratesData[0]?.rate[planType].map((item, index) => (
                              <th
                                style={{
                                  borderTop: "0.5px solid #cccccc96",
                                }}
                                key={index}
                              >
                                <span
                                  className="date_inventory text-uppercase"
                                  style={{ float: "right" }}
                                >
                                  <h4
                                    style={{
                                      color: "#fff",
                                      lineHeight: "100%",
                                    }}
                                  >
                                    {" "}
                                    {new Date(item.date).getDate()}
                                  </h4>{" "}
                                  {getMonthText(item.date)}
                                </span>{" "}
                              </th>
                            ))}
                          </React.Fragment>
                        ))}
                    </tr>

                    {/* {Object.keys(item.rate)?.map((data, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr key={data}>
                                  <td>
                                    <b>{data}</b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="font_12">Base Rate</td>
                                  {item.rate[data]?.slice(0, 7)?.map((rate, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <td>{rate.base_rate}</td>
                                      </React.Fragment>
                                    );
                                  })}
                                </tr>
                                <tr>
                                  <td className="font_12">Extra Adult</td>
                                  {item.rate[data]?.slice(0, 7)?.map((rate, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <td>{rate.extra_adult}</td>
                                      </React.Fragment>
                                    );
                                  })}
                                </tr>
                                <tr>
                                  <td className="font_12">Child with Bed</td>
                                  {item.rate[data]?.slice(0, 7)?.map((rate, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <td>{rate.child_w_bed}</td>
                                      </React.Fragment>
                                    );
                                  })}
                                </tr>
                                <tr>
                                  <td className="font_12 border-bottom">
                                    Child W/O Bed
                                  </td>
                                  {item.rate[data]?.slice(0, 7)?.map((rate, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <td className="border-bottom">
                                          {rate.child_wo_bed}
                                        </td>
                                      </React.Fragment>
                                    );
                                  })}
                                </tr>
                              </React.Fragment>
                            );
                          })} */}

                    {ratesData.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td
                            onClick={() => handleToggle(index)}
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          >
                            {activeIndex.includes(index) ? (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M6 10H14"
                                  stroke="#009A50"
                                  strokeWidth="1"
                                  strokeLinecap="round"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_7248_3375"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="20"
                                  height="20"
                                >
                                  <rect width="20" height="20" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_7248_3375)">
                                  <path
                                    d="M9.3724 10.625V13.3333C9.3724 13.5107 9.43226 13.6592 9.55198 13.7787C9.67156 13.8985 9.82003 13.9583 9.9974 13.9583C10.1748 13.9583 10.3232 13.8985 10.4428 13.7787C10.5625 13.6592 10.6224 13.5107 10.6224 13.3333V10.625H13.3307C13.5081 10.625 13.6566 10.5651 13.7761 10.4454C13.8959 10.3258 13.9557 10.1774 13.9557 9.99999C13.9557 9.82263 13.8959 9.67416 13.7761 9.55457C13.6566 9.43485 13.5081 9.37499 13.3307 9.37499H10.6224V6.66666C10.6224 6.4893 10.5625 6.34082 10.4428 6.22124C10.3232 6.10152 10.1748 6.04166 9.9974 6.04166C9.82003 6.04166 9.67156 6.10152 9.55198 6.22124C9.43226 6.34082 9.3724 6.4893 9.3724 6.66666V9.37499H6.66406C6.4867 9.37499 6.33823 9.43485 6.21865 9.55457C6.09892 9.67416 6.03906 9.82263 6.03906 9.99999C6.03906 10.1774 6.09892 10.3258 6.21865 10.4454C6.33823 10.5651 6.4867 10.625 6.66406 10.625H9.3724ZM4.42052 17.0833C3.99955 17.0833 3.64323 16.9375 3.35156 16.6458C3.0599 16.3542 2.91406 15.9978 2.91406 15.5769V4.42311C2.91406 4.00214 3.0599 3.64582 3.35156 3.35416C3.64323 3.06249 3.99955 2.91666 4.42052 2.91666H15.5743C15.9952 2.91666 16.3516 3.06249 16.6432 3.35416C16.9349 3.64582 17.0807 4.00214 17.0807 4.42311V15.5769C17.0807 15.9978 16.9349 16.3542 16.6432 16.6458C16.3516 16.9375 15.9952 17.0833 15.5743 17.0833H4.42052ZM4.42052 15.8333H15.5743C15.6384 15.8333 15.6972 15.8066 15.7505 15.7531C15.804 15.6998 15.8307 15.641 15.8307 15.5769V4.42311C15.8307 4.35895 15.804 4.3002 15.7505 4.24686C15.6972 4.19339 15.6384 4.16666 15.5743 4.16666H4.42052C4.35635 4.16666 4.2976 4.19339 4.24427 4.24686C4.1908 4.3002 4.16406 4.35895 4.16406 4.42311V15.5769C4.16406 15.641 4.1908 15.6998 4.24427 15.7531C4.2976 15.8066 4.35635 15.8333 4.42052 15.8333Z"
                                    fill="#009A50"
                                  />
                                </g>
                              </svg>
                            )}
                            <b>{item.name}</b>
                          </td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                          <td
                            className={
                              activeIndex.includes(index) ? "active_data" : ""
                            }
                          ></td>
                        </tr>
                        {activeIndex &&
                          activeIndex.includes(index) &&
                          Object.keys(item.rate).map((planType, index) => (
                            <React.Fragment key={index}>
                              <tr>
                                <td
                                  className="font_12"
                                  onClick={() =>
                                    toggleAccordion(index, planType)
                                  }
                                >
                                  {isExpanded[`${index}-${planType}`] ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_7256_3576"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="20"
                                        height="20"
                                      >
                                        <rect
                                          width="20"
                                          height="20"
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_7256_3576)">
                                        <path
                                          d="M5.21094 10.625C5.03385 10.625 4.88545 10.5651 4.76573 10.4452C4.64587 10.3253 4.58594 10.1769 4.58594 9.99979C4.58594 9.82257 4.64587 9.67417 4.76573 9.55458C4.88545 9.43486 5.03385 9.375 5.21094 9.375H14.7943C14.9714 9.375 15.1198 9.43493 15.2395 9.55479C15.3593 9.67465 15.4193 9.82313 15.4193 10.0002C15.4193 10.1774 15.3593 10.3258 15.2395 10.4454C15.1198 10.5651 14.9714 10.625 14.7943 10.625H5.21094Z"
                                          fill="#009A50"
                                        />
                                      </g>
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_7256_3582"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="20"
                                        height="20"
                                      >
                                        <rect
                                          width="20"
                                          height="20"
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_7256_3582)">
                                        <path
                                          d="M9.3776 10.625H5.21094C5.03385 10.625 4.88545 10.5651 4.76573 10.4452C4.64587 10.3253 4.58594 10.1769 4.58594 9.99979C4.58594 9.82257 4.64587 9.67417 4.76573 9.55458C4.88545 9.43486 5.03385 9.375 5.21094 9.375H9.3776V5.20833C9.3776 5.03125 9.43753 4.88285 9.5574 4.76312C9.67726 4.64326 9.82573 4.58333 10.0028 4.58333C10.18 4.58333 10.3284 4.64326 10.448 4.76312C10.5677 4.88285 10.6276 5.03125 10.6276 5.20833V9.375H14.7943C14.9714 9.375 15.1198 9.43493 15.2395 9.55479C15.3593 9.67465 15.4193 9.82312 15.4193 10.0002C15.4193 10.1774 15.3593 10.3258 15.2395 10.4454C15.1198 10.5651 14.9714 10.625 14.7943 10.625H10.6276V14.7917C10.6276 14.9687 10.5677 15.1172 10.4478 15.2369C10.328 15.3567 10.1795 15.4167 10.0024 15.4167C9.82517 15.4167 9.67677 15.3567 9.55719 15.2369C9.43747 15.1172 9.3776 14.9687 9.3776 14.7917V10.625Z"
                                          fill="#009A50"
                                        />
                                      </g>
                                    </svg>
                                  )}
                                  {planType}
                                </td>

                                <td
                                  className="font_12 text-center"
                                  style={{
                                    color: "#888888",
                                    float: "right",
                                    minWidth: "108px",
                                  }}
                                >
                                  <svg
                                    width="25"
                                    height="14"
                                    viewBox="0 0 25 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.49687 6.30001C8.65667 6.30001 9.59687 5.3598 9.59687 4.20001C9.59687 3.04021 8.65667 2.10001 7.49687 2.10001C6.33708 2.10001 5.39687 3.04021 5.39687 4.20001C5.39687 5.3598 6.33708 6.30001 7.49687 6.30001Z"
                                      fill="#888888"
                                    />
                                    <path
                                      d="M5.04687 11.9001C4.59901 11.9001 4.15114 11.7293 3.80944 11.3876C3.12602 10.7042 3.12602 9.59612 3.80944 8.9127C4.22192 8.50847 5.53687 7.70001 7.49687 7.70001C9.45687 7.70001 10.7718 8.50847 11.1843 8.9127C11.8677 9.59612 11.8677 10.7042 11.1843 11.3876C10.8426 11.7293 10.3947 11.9001 9.94688 11.9001H5.04687Z"
                                      fill="#888888"
                                    />
                                    <path
                                      d="M17.4969 6.30001C18.6567 6.30001 19.5969 5.3598 19.5969 4.20001C19.5969 3.04021 18.6567 2.10001 17.4969 2.10001C16.3371 2.10001 15.3969 3.04021 15.3969 4.20001C15.3969 5.3598 16.3371 6.30001 17.4969 6.30001Z"
                                      fill="#888888"
                                    />
                                    <path
                                      d="M15.0469 11.9001C14.599 11.9001 14.1511 11.7293 13.8094 11.3876C13.126 10.7042 13.126 9.59612 13.8094 8.9127C14.2219 8.50847 15.5369 7.70001 17.4969 7.70001C19.4569 7.70001 20.7718 8.50847 21.1843 8.9127C21.8677 9.59612 21.8677 10.7042 21.1843 11.3876C20.8426 11.7293 20.3947 11.9001 19.9469 11.9001H15.0469Z"
                                      fill="#888888"
                                    />
                                  </svg>{" "}
                                  <br />
                                  Base Rate
                                </td>
                                {item.rate[planType]
                                  ?.slice(0, 7)
                                  ?.map((rate, index) => (
                                    <td key={index}>
                                      <div
                                        style={{
                                          float: "right",
                                          textAlign: "center",
                                          overflow: 'scroll'
                                        }}
                                      >
                                        {rate.price}
                                      </div>
                                    </td>
                                  ))}
                              </tr>
                              {isExpanded[`${index}-${planType}`] && (
                                <>
                                  <tr>
                                    <td></td>
                                    <td
                                      className="font_12 text-center"
                                      style={{
                                        color: "#888888",
                                        float: "right",
                                        minWidth: "108px",
                                      }}
                                    >
                                      <svg
                                        width="15"
                                        height="14"
                                        viewBox="0 0 15 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.49687 6.30001C8.65667 6.30001 9.59687 5.3598 9.59687 4.20001C9.59687 3.04021 8.65667 2.10001 7.49687 2.10001C6.33708 2.10001 5.39687 3.04021 5.39687 4.20001C5.39687 5.3598 6.33708 6.30001 7.49687 6.30001Z"
                                          fill="#888888"
                                        />
                                        <path
                                          d="M5.04687 11.9001C4.59901 11.9001 4.15114 11.7293 3.80944 11.3876C3.12602 10.7042 3.12602 9.59612 3.80944 8.9127C4.22192 8.50847 5.53687 7.70001 7.49687 7.70001C9.45687 7.70001 10.7718 8.50847 11.1843 8.9127C11.8677 9.59612 11.8677 10.7042 11.1843 11.3876C10.8426 11.7293 10.3947 11.9001 9.94688 11.9001H5.04687Z"
                                          fill="#888888"
                                        />
                                      </svg>{" "}
                                      <br />
                                      Extra Adult
                                    </td>
                                    {item.rate[planType]
                                      ?.slice(0, 7)
                                      ?.map((rate, index) => (
                                        <td key={index}>
                                          <div
                                            style={{
                                              float: "right",
                                              textAlign: "center",
                                            }}
                                          >
                                            {rate.extraAdult}
                                          </div>
                                        </td>
                                      ))}
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td
                                      className="font_12 text-center"
                                      style={{
                                        color: "#888888",
                                        float: "right",
                                        minWidth: "108px",
                                      }}
                                    >
                                      <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_7256_3621)">
                                          <path
                                            d="M2.74956 1.75C2.74956 1.28587 2.93393 0.840752 3.26212 0.512563C3.59031 0.184374 4.03543 0 4.49956 0C4.96369 0 5.40881 0.184374 5.73699 0.512563C6.06518 0.840752 6.24956 1.28587 6.24956 1.75C6.24956 2.21413 6.06518 2.65925 5.73699 2.98744C5.40881 3.31563 4.96369 3.5 4.49956 3.5C4.03543 3.5 3.59031 3.31563 3.26212 2.98744C2.93393 2.65925 2.74956 2.21413 2.74956 1.75ZM4.06206 10.5V13.125C4.06206 13.609 3.67104 14 3.18706 14C2.70307 14 2.31206 13.609 2.31206 13.125V7.86953L1.74057 8.77734C1.48354 9.1875 0.942135 9.30781 0.534713 9.05078C0.127292 8.79375 0.00151029 8.25508 0.258542 7.84766L1.34956 6.1168C2.03042 5.03125 3.21987 4.375 4.49956 4.375C5.77925 4.375 6.9687 5.03125 7.64956 6.11406L8.74057 7.84766C8.9976 8.25781 8.87456 8.79648 8.46714 9.05352C8.05971 9.31055 7.51831 9.1875 7.26128 8.78008L6.68706 7.86953V13.125C6.68706 13.609 6.29604 14 5.81206 14C5.32807 14 4.93706 13.609 4.93706 13.125V10.5H4.06206Z"
                                            fill="#888888"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_7256_3621">
                                            <rect
                                              width="8.75"
                                              height="14"
                                              fill="white"
                                              transform="translate(0.125)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      <br />
                                      Child with Bed
                                    </td>
                                    {item.rate[planType]
                                      ?.slice(0, 7)
                                      ?.map((rate, index) => (
                                        <td key={index}>
                                          <div
                                            style={{
                                              float: "right",
                                              textAlign: "center",
                                            }}
                                          >
                                            {rate.childWithBed}
                                          </div>
                                        </td>
                                      ))}
                                  </tr>
                                  <tr>
                                    <td className="border-bottom"></td>
                                    <td
                                      className="font_12 text-center border-bottom"
                                      style={{
                                        color: "#888888",
                                        float: "right",
                                        minWidth: "108px",
                                      }}
                                    >
                                      <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_7256_3621)">
                                          <path
                                            d="M2.74956 1.75C2.74956 1.28587 2.93393 0.840752 3.26212 0.512563C3.59031 0.184374 4.03543 0 4.49956 0C4.96369 0 5.40881 0.184374 5.73699 0.512563C6.06518 0.840752 6.24956 1.28587 6.24956 1.75C6.24956 2.21413 6.06518 2.65925 5.73699 2.98744C5.40881 3.31563 4.96369 3.5 4.49956 3.5C4.03543 3.5 3.59031 3.31563 3.26212 2.98744C2.93393 2.65925 2.74956 2.21413 2.74956 1.75ZM4.06206 10.5V13.125C4.06206 13.609 3.67104 14 3.18706 14C2.70307 14 2.31206 13.609 2.31206 13.125V7.86953L1.74057 8.77734C1.48354 9.1875 0.942135 9.30781 0.534713 9.05078C0.127292 8.79375 0.00151029 8.25508 0.258542 7.84766L1.34956 6.1168C2.03042 5.03125 3.21987 4.375 4.49956 4.375C5.77925 4.375 6.9687 5.03125 7.64956 6.11406L8.74057 7.84766C8.9976 8.25781 8.87456 8.79648 8.46714 9.05352C8.05971 9.31055 7.51831 9.1875 7.26128 8.78008L6.68706 7.86953V13.125C6.68706 13.609 6.29604 14 5.81206 14C5.32807 14 4.93706 13.609 4.93706 13.125V10.5H4.06206Z"
                                            fill="#888888"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_7256_3621">
                                            <rect
                                              width="8.75"
                                              height="14"
                                              fill="white"
                                              transform="translate(0.125)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      <br /> Child W/O Bed
                                    </td>
                                    {item.rate[planType]
                                      ?.slice(0, 7)
                                      ?.map((rate, index) => (
                                        <td
                                          className="border-bottom"
                                          key={index}
                                        >
                                          <div
                                            style={{
                                              float: "right",
                                              textAlign: "center",
                                            }}
                                          >
                                            {rate.childWithoutBed}
                                          </div>
                                        </td>
                                      ))}
                                  </tr>
                                </>
                              )}
                            </React.Fragment>
                          ))}
                      </React.Fragment>
                    ))}
                  </table>
                </>
              ) : (
                <>
                  <NoDataFound />
                </>
              )}
            </div>
          )}
        </section>
        {/* </div> */}
      </div>
    </>
  );
};

export default Rates;
